// jokeUtils.js

/**
 * Counts the assigned and unassigned jokes in the provided bits array.
 * @param {Array} bitsArray - Array of bits where each bit contains an array of jokes.
 * @returns {Object} - An object containing counts for assigned and unassigned jokes.
 */
export const countAssignedAndUnassignedJokes = (bitsArray) => {
    let assignedCount = 0;
    let unassignedCount = 0;
  
    bitsArray.forEach(bit => {
      bit.forEach(joke => {
        if (typeof joke === 'object' && joke.punchline && joke.punchline.text.trim()) {
          assignedCount++; // Joke is assigned if it has a punchline
        } else {
          unassignedCount++; // Joke is unassigned if it's still a string or missing punchline
        }
      });
    });
  
    return { assignedCount, unassignedCount };
  };
  